import { render } from "./GestaoCompras.vue?vue&type=template&id=05f8f73a&scoped=true"
import script from "./GestaoCompras.vue?vue&type=script&lang=js"
export * from "./GestaoCompras.vue?vue&type=script&lang=js"

import "./GestaoCompras.vue?vue&type=style&index=0&id=05f8f73a&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f8f73a"]])

export default __exports__